var swiper = new Swiper(".product-list", {
  loop: true,
  speed: 1000,
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: '.collection-btn-next',
    prevEl: '.collection-btn-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    769: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: false,
    },
    0: {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 20,
    },
  },
  on: {
    init: function() {
      updateNavigationVisibility(this);
    },
    resize: function() {
      updateNavigationVisibility(this);
    },
    slideChange: function() {
      updateNavigationVisibility(this);
    },
  }
});

function updateNavigationVisibility(swiper) {
  const slidesPerView = swiper.params.slidesPerView;
  const totalSlides = swiper.slides.length;
  
  if (totalSlides <= slidesPerView) {
    document.querySelector('.collection-btn-next').style.display = 'none';
    document.querySelector('.collection-btn-prev').style.display = 'none';
  } else {
    document.querySelector('.collection-btn-next').style.display = '';
    document.querySelector('.collection-btn-prev').style.display = '';
  }
  const wrapper = swiper.wrapperEl;
  if (totalSlides < slidesPerView) {
    wrapper.classList.add('centered');
  } else {
    wrapper.classList.remove('centered');
  }
}
